<div id="position-station" uk-modal>
    <div class="uk-modal-dialog">
        <a class="uk-modal-close-default">
            <img src="../../../../assets/icons/Close.svg" height="32px" width="32px">
        </a>
        <div class="uk-modal-body">
            <div class="uk-display-inline-block research-form-controls uk-width-1-1 uk-margin-remove">
                <h2 class="main-title bold color-grey uk-text-uppercase">
                    Modifier la position de la station
                </h2>
                <div class="uk-margin">
                    <label class="label">Latitude</label>
                    <div class="uk-form-controls uk-margin-small-top">
                        <input [(ngModel)]="position[0]" class="input alt color-cold-grey bold uk-width-1-1" type="number" (ngModelChange)="setPositionTimeout()">
                    </div>
                </div>
                <div class="uk-margin">
                    <label class="label">Longitude</label>
                    <div class="uk-form-controls uk-margin-small-top">
                        <input [(ngModel)]="position[1]" class="input alt color-cold-grey bold uk-width-1-1" type="number" (ngModelChange)="setPositionTimeout()">
                    </div>
                </div>
                <div class="uk-margin">
                    <div style="width:100%; height: 450px;" id="reposition"></div>
                </div>
            </div>
        </div>
        <div class="uk-modal-footer">
            <p class="uk-text-right">
                <button class="button bold uk-modal-close" type="button">Annuler</button>
                <button class="button bold uk-margin-small-left" type="button" (click)="updatePosition()">
                    Modifier
                </button>
            </p>
        </div>
    </div>
</div>